import styled from '@emotion/styled';
import { Typography } from '@ui-components/neo.tax';

export const StyledTypography = styled(Typography)({
  textDecoration: 'underline',
});
